import type { SVGProps } from "react";
export interface RewardBadgeStarIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function RewardBadgeStarIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: RewardBadgeStarIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M17.625 21.247a1.875 1.875 0 0 1-2.37 1.808l-3.02-.826a.9.9 0 0 0-.348-.023l-.114.023-3.03.828a1.875 1.875 0 0 1-2.368-1.81V16.62a1.125 1.125 0 1 1 2.25 0v4.135l2.555-.697.203-.048c.478-.097.973-.08 1.445.05l2.547.695V16.62a1.125 1.125 0 1 1 2.25 0z"
      />
      <path
        fill={color}
        d="M18.875 10a6.876 6.876 0 1 0-13.751.002A6.876 6.876 0 0 0 18.876 10ZM10.88 5.454a1.376 1.376 0 0 1 2.243 0l.105.176.838 1.668 1.882.27.2.042c.896.265 1.295 1.377.7 2.14l-.144.159-1.35 1.292.317 1.82c.203 1.16-1.015 1.95-1.983 1.45L12 13.599l-1.687.873c-.968.499-2.186-.291-1.983-1.45l.317-1.821-1.349-1.292c-.845-.81-.347-2.184.756-2.341l1.881-.27.84-1.668zm.803 3.381c-.166.33-.482.556-.847.608l-.672.095.473.453c.27.259.395.637.33 1.006l-.116.664.634-.327.124-.056c.295-.11.625-.09.909.056l.632.327-.115-.664c-.065-.37.059-.747.33-1.006l.471-.453-.67-.095a1.13 1.13 0 0 1-.846-.608L12 8.201zM21.125 10a9.126 9.126 0 1 1-18.25 0 9.126 9.126 0 0 1 18.25 0"
      />
    </svg>
  );
}
